import React from 'react';
import ContentLayout from 'src/components/ContentLayout';
import Menu from './Menu';
import Content from './Content';

const Help: React.FC = () => {
  return (
    <ContentLayout
      stickySidebar
      size="fullScreen"
      sidebar={<Menu />}
      content={<Content />}
    />
  );
};

export default Help;
